export default __webpack_public_path__ + "static/media/5868.bc92f096.jpg";